import React from 'react';
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Font
} from '@react-pdf/renderer';

// Font registration (optional, built-in Helvetica is used)
Font.register({ family: 'Helvetica-Bold', src: 'Helvetica-Bold' });

const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontSize: 9,
    fontFamily: 'Helvetica',
    backgroundColor: '#fafafa',
  },
  header: {
    fontSize: 16,
    marginBottom: 10,
    textAlign: 'center',
    color: '#444',
    fontFamily: 'Helvetica-Bold',
  },
  summaryRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    backgroundColor: '#ffffff',
    border: '1px solid #ddd',
    borderRadius: 4,
    padding: 8,
    marginBottom: 15,
  },
  summaryItem: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginRight: 10,
    minWidth: '18%',
  },
  summaryLabel: {
    fontSize: 7,
    color: '#777',
  },
  summaryValue: {
    fontSize: 10,
    fontFamily: 'Helvetica-Bold',
    color: '#333',
  },
  table: {
    width: '100%',
    border: '1px solid #eee',
    borderRadius: 4,
  },
  tableHeader: {
    flexDirection: 'row',
    backgroundColor: '#f0f0f0',
    borderBottom: '1px solid #ddd',
    fontFamily: 'Helvetica-Bold',
    fontSize: 8,
    paddingVertical: 5,
  },
  tableRow: {
    flexDirection: 'row',
    fontSize: 8,
    paddingVertical: 4,
    borderBottom: '1px solid #eee',
  },
  tableRowAlt: {
    backgroundColor: '#f9f9f9',
  },
  cell: {
    flex: 1,
    paddingHorizontal: 4,
  },
  cellRight: {
    flex: 1,
    paddingHorizontal: 4,
    textAlign: 'right',
  },
});

const formatAmount = (amount) => `Rs. ${Number(amount || 0).toFixed(2)}`;

const TransactionPdf = ({ transactions = [], summary = {} }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <Text style={styles.header}>Transaction Report</Text>

      <View style={styles.summaryRow}>
        {[{
          label: 'Total Order Amount',
          value: summary.totalOrderAmount
        }, {
          label: 'Vendor Earning',
          value: summary.totalVendorEarning
        }, {
          label: 'Platform Commission',
          value: summary.totalPlatformCommission
        }, {
          label: 'Tax Amount',
          value: summary.totalTaxAmount
        }, {
          label: 'Delivery Charge',
          value: summary.totalDeliveryCharge
        }].map((item, i) => (
          <View key={i} style={styles.summaryItem}>
            <Text style={styles.summaryLabel}>{item.label}</Text>
            <Text style={styles.summaryValue}>{formatAmount(item.value)}</Text>
          </View>
        ))}
      </View>

      <View style={styles.table}>
        <View style={styles.tableHeader}>
          <Text style={styles.cell}>Order ID</Text>
          <Text style={styles.cell}>Vendor</Text>
          <Text style={styles.cellRight}>Order Amt</Text>
          <Text style={styles.cellRight}>Earning</Text>
          <Text style={styles.cellRight}>Platform</Text>
          <Text style={styles.cellRight}>Tax</Text>
          <Text style={styles.cell}>Date</Text>
        </View>

        {transactions && Array.isArray(transactions) && transactions.map((item, i) => (
          <View
            key={item.id || i}
            style={[styles.tableRow, i % 2 === 1 ? styles.tableRowAlt : {}]}
          >
            <Text style={styles.cell}>{item.orderId}</Text>
            <Text style={styles.cell}>{item.vendor_name}</Text>
            <Text style={styles.cellRight}>{formatAmount(item.orderAmount)}</Text>
            <Text style={styles.cellRight}>{formatAmount(item.vendorEarning)}</Text>
            <Text style={styles.cellRight}>{formatAmount(item.platformCommission)}</Text>
            <Text style={styles.cellRight}>{formatAmount(item.taxAmount)}</Text>
            <Text style={styles.cell}>{item.createdAt.split(' ')[0]}</Text>
          </View>
        ))}
      </View>
    </Page>
  </Document>
);

export default TransactionPdf;
